var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('HeaderBar'),_c('SideBar'),(_vm.isLoggedIn)?_c('v-main',[_c('router-view')],1):_vm._e(),_c('Lightbox'),_c('Alerts'),_c('ConfirmBox'),_c('SavePromptBox'),_c('WaitingAnimation'),_c('CurationLock'),_c('Login')],1)}
var staticRenderFns = []

export { render, staticRenderFns }